import {LoginModal, PosaRedeemStore, RedeemSectionData, GiftcardConfig} from '../../utils/types';

import LoggedInSection from './RedeemSectionLoggedIn';
import React from 'react';
import UnLoggedInSection from './RedeemSectionUnLoggedIn';
import VerifiedCodeSection from './RedeemSectionVerifiedCode';

export interface Props {
  posaRedeemStore: PosaRedeemStore;
  accountName: string;
  landingPageViewed: boolean;
  isLoggedIn: boolean;
  uppercaseCode: boolean;
  data: RedeemSectionData;
  getStartAction: () => void;
  loginModal: LoginModal;
  prefilledCode: string;
  giftcardConfig: GiftcardConfig;
}

const RedeemSection = ({
  posaRedeemStore,
  accountName,
  landingPageViewed,
  isLoggedIn,
  uppercaseCode,
  data,
  getStartAction,
  loginModal,
  prefilledCode,
  giftcardConfig,
}: Props) => {
  const {code, codeVerified} = posaRedeemStore;
  if (code && codeVerified)
    return (
      <VerifiedCodeSection
        data={data}
        posaRedeemStore={posaRedeemStore}
        accountName={accountName}
      />
    );
  if (landingPageViewed && isLoggedIn && !codeVerified) {
    return (
      <LoggedInSection
        posaRedeemStore={posaRedeemStore}
        uppercaseCode={uppercaseCode}
        data={data}
        prefilledCode={prefilledCode}
        accountName={accountName}
        giftcardConfig={giftcardConfig}
      />
    );
  }
  return (
    <UnLoggedInSection
      data={data}
      getStartAction={getStartAction}
      loginModal={loginModal}
      giftcardConfig={giftcardConfig}
    />
  );
};

export default RedeemSection;
